import { HttpMethods, makeRequest } from "../helpers/http.helper";
import type {
  AttachSupplierAgreementDocumentInput,
  SetSupplierAgreementPriceInput,
  SupplierAgreementDocument,
  SupplierAgreementPrice,
} from "../types/supplier-agreement.type";

export const setSupplierAgreementPrice = async (
  organizationId: string,
  supplierId: string,
  input: SetSupplierAgreementPriceInput,
): Promise<SupplierAgreementPrice> => {
  const raw = await makeRequest({
    url: `/ops/suppliers/${supplierId}/agreement/prices`,
    method: HttpMethods.POST,
    params: { organization_id: organizationId },
    data: input,
  });
  return (raw as { result: SupplierAgreementPrice }).result;
};

export const listSupplierAgreementPrices = async (
  organizationId: string,
  supplierId: string,
): Promise<SupplierAgreementPrice[]> => {
  const raw = await makeRequest({
    url: `/ops/suppliers/${supplierId}/agreement/prices`,
    method: HttpMethods.GET,
    params: { organization_id: organizationId },
  });
  return (raw as { result: SupplierAgreementPrice[] }).result;
};

export const attachSupplierAgreementDocument = async (
  organizationId: string,
  supplierId: string,
  input: AttachSupplierAgreementDocumentInput,
): Promise<SupplierAgreementDocument> => {
  const raw = await makeRequest({
    url: `/ops/suppliers/${supplierId}/agreement/documents`,
    method: HttpMethods.POST,
    params: { organization_id: organizationId },
    data: input,
  });
  return (raw as { result: SupplierAgreementDocument }).result;
};

export const listSupplierAgreementDocuments = async (
  organizationId: string,
  supplierId: string,
): Promise<SupplierAgreementDocument[]> => {
  const raw = await makeRequest({
    url: `/ops/suppliers/${supplierId}/agreement/documents`,
    method: HttpMethods.GET,
    params: { organization_id: organizationId },
  });
  return (raw as { result: SupplierAgreementDocument[] }).result;
};

export const archiveSupplierAgreementDocument = async (
  organizationId: string,
  supplierId: string,
  documentId: string,
): Promise<void> => {
  await makeRequest({
    url: `/ops/suppliers/${supplierId}/agreement/documents/${documentId}`,
    method: HttpMethods.DELETE,
    params: { organization_id: organizationId },
  });
};
